import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FunnelService } from 'src/app/pages/new-service/services/funnel.service';

@Component({
    selector: 'app-delete-file-modal',
    templateUrl: './delete-file-modal.component.html',
    styleUrls: ['./delete-file-modal.component.scss'],
})
export class DeleteFileModalComponent {

    constructor(
        public dialogRef: MatDialogRef<DeleteFileModalComponent>,
        // deleteFromBackend distingue quitar el fichero del servicio de borrarlo
        // de verdad. Un fichero guardado para próximos servicios se despega del
        // servicio pero sigue existiendo; uno temporal no le sirve ya a nadie.
        @Inject(MAT_DIALOG_DATA) public data: { pdfId: string; deleteFromBackend: boolean; clientId?: string; },
        private funnelService: FunnelService,
    ) {
    }

    close() {
        this.dialogRef.close();
    }

    delete() {
        if (this.data.deleteFromBackend) {
            this.funnelService.deleteFileOrLink(this.data.pdfId, this.data.clientId).subscribe(() => {
                this.dialogRef.close(true);
            },
                (error) => {
                    console.error('Error deleting file:', error);
                });
        } else {
            this.dialogRef.close(true);
        }
    }
}
